const UNIT_NAME_TO_SHORT: Record<string, string> = {
  Kilogrami: 'kg',
  Litri: 'l',
  Gabali: 'gab',
  Stundas: 'h',
  Metri: 'm',
  Kvadrātmetri: 'm²',
  Kubikmetri: 'm³',
  Iepakojums: 'iep',
  Cits: 'cits',
};

export const getUnitShort = (unitName: string): string => {
  return UNIT_NAME_TO_SHORT[unitName] || unitName;
};
